import React, { useState } from 'react';
import { Tabs } from 'antd';
import HolisticProjectReportsTypeTab from './HolisticQuarterlyReportsTypeTab';

function LegacyHolisticProjectReportsTab({
  sharedFilters,
  onSharedFiltersChange,
  initialReportCategory = 'pending',
}) {
  const [reportCategory, setReportCategory] = useState(initialReportCategory);

  const activeReportStatus = {
    pending: 'PENDING',
    approved: 'APPROVED',
    hold: 'HOLD',
    draft: 'DRAFT',
    rejected: 'REJECTED',
  }[reportCategory];

  return (
    <Tabs activeKey={reportCategory} onChange={(key) => setReportCategory(key)}>
      <Tabs.TabPane tab="Pending" key="pending">
        <HolisticProjectReportsTypeTab
          reportStatus="PENDING"
          activeReportStatus={activeReportStatus}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={onSharedFiltersChange}
          reportCategoryKey="pending"
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Approved" key="approved">
        <HolisticProjectReportsTypeTab
          reportStatus="APPROVED"
          activeReportStatus={activeReportStatus}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={onSharedFiltersChange}
          reportCategoryKey="approved"
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="On Hold" key="hold">
        <HolisticProjectReportsTypeTab
          reportStatus="HOLD"
          activeReportStatus={activeReportStatus}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={onSharedFiltersChange}
          reportCategoryKey="hold"
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Drafts" key="draft">
        <HolisticProjectReportsTypeTab
          reportStatus="DRAFT"
          activeReportStatus={activeReportStatus}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={onSharedFiltersChange}
          reportCategoryKey="draft"
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Rejected" key="rejected">
        <HolisticProjectReportsTypeTab
          reportStatus="REJECTED"
          activeReportStatus={activeReportStatus}
          sharedFilters={sharedFilters}
          onSharedFiltersChange={onSharedFiltersChange}
          reportCategoryKey="rejected"
        />
      </Tabs.TabPane>
    </Tabs>
  );
}

export default LegacyHolisticProjectReportsTab;
